import React, { useEffect,useReducer, useState , useRef} from 'react';
import { Spin, Modal, notification, Upload, Popconfirm, message, Avatar, Empty, AutoComplete, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker } from 'antd';
import { CheckCircleTwoTone, CheckCircleFilled } from "@ant-design/icons"
import './linkedMIDModal.css'

import { connect , useDispatch} from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../actions/index';
import NESARegistrations from "../MaintainAlumni/NESARegistrations";
import noAwardsPng from '../AlumniProfile/noawards.png'
import { object } from 'prop-types';
import NesaRegistrationsInfoModal from './NesaRegistationInfoModal';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const currentDate =  moment().format('MM/DD/YYYY');


const initialState = {
  AllExtendedProfileAwardsArray: [],
  AllEagleInfo: [],
  AllAlumniAwards: [],
  hasCurrentNESAmembership: false,
  EagleScoutInfoVisible: false,
  showNESARegistrationsModal: false,
  activeMembership: [],
  selectedActiveMember: undefined,
  isEditableAwardsFrame: false,
  InfoVisible: false,
  pathName: null,
  scoutingaffiliations: [],
  councilaffiliations: [],
  localAwards: [],
  affinities: [],
  selectedAward: [],
  isShowLinkedMIDPopup: false,
  selectedLinkedMID: 0,
  privacysettingsOptions: {
    // isNameDisplayed: true,
    // isAddressDisplayed: false,
    // isTelephoneDisplayed: false,
    // isEmailDisplayed: false,
    // isEagleCouncilNameDisplayed: false,
    // isEagleUnitNumberDisplayed: false,
    // isEagleUnitCityDisplayed: false,
    // isEagleUnitStateDisplayed: false,
    // isCouncilAffiliationsDisplayed: false,
    // isScoutingAffiliationsDisplayed: false,
    // isAwardsDisplayed: false,
    // isAffinityGroupsDisplayed: false
}
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'renamedAffiliations':
      return { ...state, renamedAffiliations: action.renamedAffiliations  };

    case 'getEagleCouncilInfo':
      return { ...state, getEagleCouncilInfo: action.getEagleCouncilInfo  };
    
      case 'setAllExtendedProfileAwardsArray':
      return { ...state, AllExtendedProfileAwardsArray: action.extendedProfile  };

    case 'setAllEagleInfo':
      return { ...state, AllEagleInfo: action.eagleInfo  };

    case 'setAllAlumniAwards':
      return { ...state, AllAlumniAwards: action.alumniAwards  };

    case 'setNESARegistration':
      return { ...state, nesaRegistration: action.nesaRegistration  };

    case 'currentMembership':
      return { ...state, hasCurrentNESAmembership: true , activeMembership: action.getActiveMembership  };

    case 'selectedActiveMember':
      return { ...state, selectedActiveMember: action.selectedActiveMember  };

    case 'showEagleScoutInformation':
      return { ...state, EagleScoutInfoVisible: true };

    case 'closeEagleScoutInformation':
      return { ...state, EagleScoutInfoVisible: false };

    case 'showNESARegistrationsModal':
      return { ...state, showNESARegistrationsModal: true };

    case 'hideNESARegistrationsModal':
      return { ...state, showNESARegistrationsModal: false };

    case 'showInfoVisiblePopup':
      return { ...state, InfoVisible: true };

    case 'closeInfoVisiblePopup':
      return { ...state, InfoVisible: false };

    case 'selectedAward':
      return { ...state, selectedAward: [action.award] };

    case 'selectedLinkedMID':
      return { ...state, selectedLinkedMID: action.selectedLinkedMID };

    case 'showLinkedMIDPopup':
      return { ...state, isShowLinkedMIDPopup: true };

    case 'closeLinkedMIDPopup':
      return { ...state, isShowLinkedMIDPopup: false };

    case 'EditableAwardsFrame':
      return { ...state, isEditableAwardsFrame: action.isEditableAwardsFrame, pathName: action.pathName };
    
      case 'FilteredScoutingAffiliations':
      return { ...state, scoutingaffiliations: action.scoutingaffiliations}
      
      case 'FilteredCouncilAffiliations':
      return { ...state, councilaffiliations: action.councilaffiliations}
      
      case 'FilteredLocalAwards':
      return { ...state, localAwards: action.localAwards}
      
      case 'FilteredAffinities':
      return { ...state, affinities: action.affinities}

      case 'setAlumniPrivacyOptions':
      return { ...state, privacysettingsOptions: action.privacysettingsOptions}

      case 'FilteredAwards':
      return { ...state,
        scoutingaffiliations: action.scoutingaffiliations,
        councilaffiliations: action.councilaffiliations, 
        localAwards: action.localAwards, 
        affinities: action.affinities
        };

    default:
     return state;
  }
};


// const filterAwards = (extendedProfileAwards, privacysettingsOptions) => {
//   let scoutingaffiliations = [],
//     councilaffiliations = [],
//     localAwards = [],
//     affinities = [];
//     const {isScoutingAffiliationsDisplayed, isCouncilAffiliationsDisplayed, isAffinityGroupsDisplayed, isAwardsDisplayed} = privacysettingsOptions;

//   extendedProfileAwards.forEach((award) => {
//     const { attributeId, attributeVal } = award;

//     if (attributeId === '20') {
//       if (isScoutingAffiliationsDisplayed) scoutingaffiliations.push(award);
//     } else if (attributeId === '21') {
//       if (isCouncilAffiliationsDisplayed) councilaffiliations.push(award);
//     } else if (attributeId === '22') {
//       if (isAffinityGroupsDisplayed) affinities.push(award);
//     } else if (attributeId === '24') {
//       if (isAwardsDisplayed) localAwards.push(award);
//     }
//   });

//   return {
//     scoutingaffiliations,
//     councilaffiliations,
//     localAwards,
//     affinities
//   };
// };

// Group awards by attributeVal
const groupedAwards = (awards, forNationalAwards) => {
  // Group awards by attributeVal
  const groupedAwards = awards.reduce((result, award) => {
    const key = award.attributeVal;
  
    // Create an array for the key if it doesn't exist
    result[key] = result[key] || [];
  
    // Push the award to the array for the key
    if(forNationalAwards) {
      result[key].push({
       ...award
      });
    }
    else result[key].push({
      extendedProfileId: award.extendedProfileId,
      affinityGroup: award.affinityGroup,
      personGuid: award.personGuid,
      memberId: award.memberId,
      attributeVal: award.attributeVal,
    });
  
    return result;
  }, {});
  
  // Convert the groupedAwards object into an array of objects
 const resultArray = Object.keys(groupedAwards).map((key) => ({
    attributeVal: key,
    awards: groupedAwards[key],
  }));
  
  return resultArray
  
};

// Convert the groupedAwards object into an array of objects
const resultArray = Object.keys(groupedAwards).map((key) => ({
  attributeVal: key,
  awards: groupedAwards[key],
}));
function MyAwardsComponent(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  const PersonGUID = props.match.params.personGuid;

  const { pathname } = props.location;
  let isEditableAwardsFrame, pathName, forSelfView = false;
  console.log('location.pathname ', pathname);

  if (pathname === '/my-profile' || pathname === '/manage-memberid' || pathname == '/alumni-dashboard') {
    forSelfView = true;
    pathName = pathname
  }
  if (pathname === '/my-profile') {
    isEditableAwardsFrame = true;
    pathName = pathname
  }
  else {
    isEditableAwardsFrame = false;
    pathName = pathname
  }

  const selectedAward = (award) => {
    dispatch({ type: "selectedAward", award });
  
    let index = award.awards.findIndex(eachAward => !eachAward.alreadyExist);
    index = index !== -1 ? index : 0
    const selectedLinkedMID = {
      award: award.awards[index],
      index,
    };
  
    dispatch({ type: 'selectedLinkedMID', selectedLinkedMID });
  };

  const showLinkedMIDPopup = () =>{
    dispatch({ type: "showLinkedMIDPopup"})
  }
  const closeLinkedMIDPopup = () =>{
    dispatch({ type: "closeLinkedMIDPopup"})
  }

  const showEagleScoutInformationPopup = () =>{
    dispatch({ type: 'showEagleScoutInformation' })
  }
  
  const closeEagleScoutInformationPopup = () =>{
    dispatch({ type: 'closeEagleScoutInformation' })
  }
  const showInfoVisiblePopup = () =>{
    dispatch({ type: "showInfoVisiblePopup"})
  }
  const closeInfoVisiblePopup = () =>{
    dispatch({ type: "closeInfoVisiblePopup"})
  }

  const checkWhetherItsAnArrayOfObj = arr => arr.length > 0 && arr.every(item => typeof item === 'object' && item !== null);

  const processNESARegistration = (memberIDs, scoutings, isEditableAwardsFrame, pathName, nesa_reg, profileinfo, eagleInfo) => {
    let ActiveMembership = [];
  
     if (forSelfView) {
        const personGuid = '';
        const extendedProfile = '';
        const memberId = '';
        props.memberids.map(eachMemberId => {
          if (checkWhetherItsAnArrayOfObj(eachMemberId.NESARegistrations)) {
            eachMemberId.NESARegistrations.forEach((registration, index) => {
              let effectiveDate = moment(registration.effectiveDate).format('MM/DD/YYYY')
              let expireDate = registration.expireDate ? moment(registration.expireDate).format('MM/DD/YYYY') : null;
              if (moment(currentDate).isSameOrAfter(effectiveDate) && (expireDate == null || moment(currentDate).isSameOrBefore(expireDate))) {
                const getAffiliation = scoutings.find(affiliation => affiliation.name === "National Eagle Scout Association");
                const activeMembershipObj = {
                  NESARegistrations: registration,
                  Affiliation: getAffiliation,
                  eagleInfo: eachMemberId.eagleInfo,
                  personGuid: registration.personGuid,
                  // extendedProfile,
                  memberId: registration.memberId,
                };
                ActiveMembership.push(activeMembershipObj);
              }
            });
          }
        });
  } else {
      if (Array.isArray(nesa_reg) && nesa_reg.length > 0 && scoutings) {
        const personGuid =  profileinfo.personGuid ? profileinfo.personGuid : profileinfo.profile.personGuid
        const extendedProfile = profileinfo.extendedProfileAttributes;
        const memberId =  profileinfo.memberId ?  profileinfo.memberId :  profileinfo.profile.memberId
        nesa_reg.forEach((registration, index) => {
          let effectiveDate = moment(registration.effectiveDate).format('MM/DD/YYYY')
          let expireDate = registration.expireDate ? moment(registration.expireDate).format('MM/DD/YYYY') : null;
          if (moment(currentDate).isSameOrAfter(effectiveDate) && (expireDate == null || moment(currentDate).isSameOrBefore(expireDate))) {
            const getAffiliation = scoutings.find(affiliation => affiliation.name === "National Eagle Scout Association");
            const activeMembershipObj = {
              NESARegistrations: registration,
              Affiliation: getAffiliation,
              eagleInfo: eagleInfo,
              personGuid,
              extendedProfile,
              memberId,
            };
            ActiveMembership.push(activeMembershipObj);
          }
        });
    }
  }
    
  return ActiveMembership;
  };
useEffect(() => {
  if(forSelfView){
    pathName != '/manage-memberid' ? props.actions.getmemberid(null, true, null, true, true) : ''
    props.actions.getAlumniAndLocalAwards()
    props.actions.getScoutingAffiliations()
    props.actions.getCouncilAffiliations()
    props.actions.getAffinityGroups()
  }
  else{
    props.actions.getOrUpdateAlumniPrivacyOptions(PersonGUID);
  }
    // if(props.forAlumniProfile){
    //     let PersonGUID = props.match.params.personGuid
      
    // }
  
}, [])

useEffect(() => {
  if (!props.isLoadingPrivacySettings && (props.privacysettingsOptions && Object.keys(props.privacysettingsOptions).length > 0)) {
    dispatch({
      type: 'setAlumniPrivacyOptions',
      privacysettingsOptions: props.privacysettingsOptions
    });
    if ( pathName.includes('/alumni-profile') ) {
      props.actions.getAlumniInfo( PersonGUID, 'alumni' );
    }
  }
}, [props.isLoadingPrivacySettings, props.privacysettingsOptions])

  useEffect(() => {
    if (props.profileinfo && Object.keys(props.profileinfo).length > 0) {

      if (!props.councilByZipLoading && (props.councilByZip && Object.keys(props.councilByZip).length > 0)) {
        if (state.getEagleCouncilInfo && state.getEagleCouncilInfo.length > 0 && state.getEagleCouncilInfo.filter(eagleInfo => eagleInfo.attributeVal && eagleInfo.attributeVal.includes(props.councilByZip.councilName)).length == 0) {

          let getEagleCouncilInfo = [
            ...state.getEagleCouncilInfo,
            {
              "extendedProfileId": undefined,
              "councilAffiliation": props.councilByZip.councilName,
              "personGuid": props.profileinfo.profile.personGuid ? props.profileinfo.profile.personGuid : props.alumniprops.profileinfo.personGuid,
              "memberId": props.profileinfo.profile.memberId ? props.profileinfo.profile.memberId : props.alumniProfileinfo.memberId,
              "attributeVal": props.councilByZip.councilName
            }]
          dispatch({ type: 'getEagleCouncilInfo', getEagleCouncilInfo });
        }
      }
      else if (state.getEagleCouncilInfo && state.getEagleCouncilInfo.length == 0) {
        let getEagleCouncilInfo = [{
          "extendedProfileId": undefined,
          "councilAffiliation": props.councilByZip.councilName,
          "personGuid": props.profileinfo.profile.personGuid ? props.profileinfo.profile.personGuid : props.alumniprops.profileinfo.personGuid,
          "memberId": props.profileinfo.profile.memberId ? props.profileinfo.profile.memberId : props.alumniProfileinfo.memberId,
          "attributeVal": props.councilByZip.councilName
        }]
        dispatch({ type: 'getEagleCouncilInfo', getEagleCouncilInfo });
      }
    }
  }, [props.councilByZipLoading, props.councilByZip, props.profileinfo])


const filterAwards = (extendedProfileAwards, privacysettingsOptions) => {
  let scoutingaffiliations = [],
    councilaffiliations = [],
    localAwards = [],
    affinities = [];
    const {isScoutingAffiliationsDisplayed, isCouncilAffiliationsDisplayed, isAffinityGroupsDisplayed, isLocalAwardsDisplayed} = privacysettingsOptions;

  extendedProfileAwards.forEach((award) => {
    const { attributeId, attributeVal } = award;

    if (attributeId === '20') {
      if (props.isadmin || isScoutingAffiliationsDisplayed) scoutingaffiliations.push(award);
    } else if (attributeId === '21') {
      if (props.isadmin || isCouncilAffiliationsDisplayed) councilaffiliations.push(award);
    } else if (attributeId === '22') {
      if (props.isadmin || isAffinityGroupsDisplayed) affinities.push(award);
    } else if (attributeId === '24') {
      if (props.isadmin || isLocalAwardsDisplayed) localAwards.push(award);
    } 
  });

  return {
    scoutingaffiliations,
    councilaffiliations,
    localAwards,
    affinities
  };
};


  useEffect(() => {
    if(props.forAlumniProfile && pathname.includes('/alumni-profile') && ((props.alumniProfileinfo && props.alumniProfileinfo.extendedProfileAttributes) && props.alumniAwards && props.alumniEagleinfo)){

      if (props.alumniProfileinfo && props.alumniProfileinfo.addresses.length > 0 && !props.councilByZipLoading) {
        const primaryAddress = props.alumniProfileinfo.addresses.find(eachAddress => eachAddress.isPrimary)
        if(primaryAddress.zipCode) props.actions.getCouncilByZipCode(primaryAddress.zipCode);
      }

        const alumniMembersExtendedProfile = props.alumniProfileinfo.extendedProfileAttributes;
        let getActiveMembership = [];
        getActiveMembership = processNESARegistration(null, state.renamedAffiliations, null, pathName, props.nesa_reg, props.alumniProfileinfo); //processNESARegistration's payload => memberIDs, scoutings, isEditableAwardsFrame, pathName, nesa_reg, profileinfo, eagleInfo
        (getActiveMembership.length != 0) && dispatch(
          {
            type : 'currentMembership',
            getActiveMembership
          });

          if (props.alumniAwards.length !== 0) {
            let getAllAlumniAwards = [];
          
            if (props.alumniAwards.awards.length !== 0) {
          
              props.alumniAwards.awards.forEach(eachAward => {
                getAllAlumniAwards.push({
                  memberId: props.alumniAwards.memberId,
                  personGuid: props.alumniAwards.personGuid,
                  awards: [eachAward],
                  attributeVal: eachAward.name
                })
              });
            }
            dispatch({ type: 'setAllAlumniAwards', alumniAwards: getAllAlumniAwards });
          }
          
          const getFilteredAwards = filterAwards(alumniMembersExtendedProfile, state.privacysettingsOptions)
          getFilteredAwards & dispatch({
            type:'FilteredAwards',
            scoutingaffiliations: getFilteredAwards.scoutingaffiliations,
            councilaffiliations: getFilteredAwards.councilaffiliations,
            affinities: getFilteredAwards.affinities,
            localAwards: getFilteredAwards.localAwards,
            nationalAwards: getFilteredAwards.nationalAwards,
            })
        dispatch({ type: 'setAllExtendedProfileAwardsArray', extendedProfile: alumniMembersExtendedProfile });

        if (props.alumniEagleinfo && props.alumniEagleinfo.currentOrganization) { //Show the councils associated with MID under the 'My Council Affiliation' section — AAG-1193.
          let getEagleCouncilInfo = [{
               "extendedProfileId": undefined,
               "councilAffiliation": props.alumniEagleinfo.currentOrganization.name,
               "personGuid": props.alumniProfileinfo.personGuid,
               "memberId": props.alumniEagleinfo.memberId,
               "attributeVal": props.alumniEagleinfo.currentOrganization.name
           }]
         dispatch({ type: 'getEagleCouncilInfo', getEagleCouncilInfo });
       }
        
    }
   
    else if (forSelfView) {

      //  || (props.alumniAndLocalAwardsReducerState && !props.loadingAlumniAndLocalAwards) || props.memberids || !props.scoutingAffiliationsLoading || !props.councilAffiliationsLoading || !props.affinityGroupsLoading) {
        if (props.profileinfo) {
          const primaryAddress = props.profileinfo.addresses.find(eachAddress => eachAddress.isPrimary)
          if(primaryAddress.zipCode) props.actions.getCouncilByZipCode(primaryAddress.zipCode);
        }
        
      if (Array.isArray(props.memberids) && props.memberids.length > 0 && state.renamedAffiliations) {


        const getAllEagleInfo = props.memberids.map(eachMID => eachMID.eagleInfo).filter(eachEagleInfo => eachEagleInfo.eagleCouncilName)
        let getActiveMembership = [];
        getActiveMembership = processNESARegistration(null, state.renamedAffiliations, null, pathName, props.nesa_reg, props.profileinfo, null); //processNESARegistration's payload => memberIDs, scoutings, isEditableAwardsFrame, pathName, nesa_reg, profileinfo, eagleInfo
        if(getActiveMembership.length != 0) dispatch(
          {
            type: 'currentMembership',
            getActiveMembership
          });

          if(getAllEagleInfo.length != 0) dispatch({ type: 'setAllEagleInfo', eagleInfo: getAllEagleInfo })

          let getEagleCouncilInfo = props.memberids.map(memberDetails => { //Show the councils associated with MID under the 'My Council Affiliation' section — AAG-1193.
            if (memberDetails) {
              return {
                "extendedProfileId": undefined,
                "councilAffiliation": memberDetails.councilName,
                "personGuid": memberDetails.personGuid,
                "memberId": memberDetails.memberId,
                "attributeVal": memberDetails.councilName
              }
            }
          })
          dispatch({ type: 'getEagleCouncilInfo', getEagleCouncilInfo });
      }

      if ((Array.isArray(props.alumniAndLocalAwardsReducerState) && props.alumniAndLocalAwardsReducerState.length > 0)) {
        const getAllLocalAwards = [];
        const getAllAlumniAwards = [];
        props.alumniAndLocalAwardsReducerState.forEach(eachPerson => {
          eachPerson.localAwards.forEach(eachLocalAward => {
            getAllLocalAwards.push({
              memberId: eachPerson.memberId,
              personGuid: eachPerson.personGuid,
              attributeVal: eachLocalAward.name,
              ...eachLocalAward
            });
          });

          eachPerson.alumniAwards.forEach(eachAlumniAward => {
            getAllAlumniAwards.push({
              memberId: eachPerson.memberId,
              personGuid: eachPerson.personGuid,
              attributeVal: eachAlumniAward.name,
              ...eachAlumniAward
            });
          });
        });
        dispatch({ type: 'FilteredLocalAwards', localAwards: sortAwards(getAllLocalAwards) })
        dispatch({ type: 'setAllAlumniAwards', alumniAwards: sortAwards(getAllAlumniAwards) });
      }

      if (Array.isArray(props.scoutingAffiliationsReducerState) && props.scoutingAffiliationsReducerState.length > 0) {
        let Affiliations = [...props.scoutingAffiliationsReducerState[0].alumniScoutingAssociations]
        let renamedAffiliations = props.scoutingAffiliationsReducerState[0].alumniScoutingAssociations.map(affiliation => {
          return affiliation.scoutingAssociation === 'Alumni Association'
            ? { ...affiliation, scoutingAssociation: 'Scouting Alumni' }  // Return a new object with the name changed // from  'Alumni Association' to 'Scouting Alumni' // AAG-1197
            : affiliation;  // If not matching, return the original object
        });
        props.scoutingAffiliationsReducerState[0].alumniScoutingAssociations = [...renamedAffiliations];
        const getScoutingAffiliations = mapAffiliations(props.scoutingAffiliationsReducerState, "alumniScoutingAssociations", "scoutingAssociation"); 
        dispatch({ type: 'FilteredScoutingAffiliations', scoutingaffiliations: sortAwards(getScoutingAffiliations) })
      }
      if (Array.isArray(props.councilAffiliationsReducerState) && props.councilAffiliationsReducerState.length > 0) {
        const getCouncilAffiliations = mapAffiliations(props.councilAffiliationsReducerState, "alumniCouncilAffiliations", "councilAffiliation");
        dispatch({ type: 'FilteredCouncilAffiliations', councilaffiliations: sortAwards(getCouncilAffiliations) })
      }
      if (Array.isArray(props.affinityGroupsReducerState) && props.affinityGroupsReducerState.length > 0) {
        const getAffinityGroups = mapAffiliations(props.affinityGroupsReducerState, "alumniAffinityGroups", "affinityGroup");
        dispatch({ type: 'FilteredAffinities', affinities: sortAwards(getAffinityGroups) })
      }


      // Dispatch actions to update the state with profile info, eagle info, and awards
      // dispatch({ type: 'setAllExtendedProfileAwardsArray', extendedProfile: props.profileinfo.extendedProfile });

      dispatch({ type: 'setNESARegistration', nesaRegistration: props.nesa_reg });

    }
  }, [props.memberIDs, props.memberids, props.profileinfo, props.eagleInfo, state.renamedAffiliations, props.awards, props.nesa_reg, props.forAlumniProfile, props.alumniAndLocalAwardsReducerState, props.loadingAlumniAndLocalAwards, props.scoutingAffiliationsReducerState, props.councilAffiliationsReducerState, props.affinityGroupsReducerState, props.scoutingAffiliationsLoading, props.councilAffiliationsLoading, props.affinityGroupsLoading, props.alumniProfileinfo, props.alumniEagleinfo]);

  useEffect(() => {
    if (Array.isArray(props.scoutings) && props.scoutings.length > 0) {
      
      let renamedAffiliations = props.scoutings.map(affiliation => {
        return affiliation = affiliation.name === 'Alumni Association' ? { ...affiliation, name : 'Scouting Alumni' } : affiliation
      })
      dispatch({ type: 'renamedAffiliations', renamedAffiliations }); 
    }
  }, [props.scoutings])
  
  const mapAffiliations = (array, affiliationKey, attributeKey) => { // to transform the data as we want
    return array.flatMap(person => {
              const { personGuid, memberId, ...rest } = person;
              const alumniAffiliations = person[affiliationKey].map(affiliation => ({
                  ...affiliation,
                  personGuid,
                  memberId,
                  attributeVal: affiliation[attributeKey],
              }));
              return alumniAffiliations;
          });
}

  const sortAwards = (awards) => awards.sort((a, b) => a.attributeVal.localeCompare(b.attributeVal));

  const renderEagleMembershipInfo = () => {
    return (
      <div className="EagleMembershipInfo">
        <span className="MembershipTypeInfo">Membership Type: </span>
        <span className="MembershipTypeInfoValue">{state.selectedActiveMember.NESARegistrations.programId === 30 ? 'NESA 5Year' : 'NESA Lifetime'}</span>
        
        <span className="MembershipExpirationDate">Expiration Date: </span>
            <span className="MembershipExpirationDateValue">{state.selectedActiveMember.NESARegistrations.expireDate ? moment(state.selectedActiveMember.NESARegistrations.expireDate).format('MM/DD/YYYY') : "-"}
            </span>
      </div>
    )
}

  const renderLocalAwardsSection = () => {
    if (props.localAwards && state.localAwards) {
      let localAwardsLookup = [...props.localAwards];
      let existingLocalAwards = state.localAwards;

      existingLocalAwards.forEach((k, kindex) => {
        if (k.attributeId === '24') {
          localAwardsLookup = localAwardsLookup.filter(function (obj) {
            return obj.name !== k.attributeVal;
          });
        }
      });

      // Removing duplicate awards
      let uniqueLocalAwards = [];
      let uniqueAwardname = {};
      let awardTitle;

      for (let i in localAwardsLookup) {
        awardTitle = localAwardsLookup[i]['name'];
        uniqueAwardname[awardTitle] = localAwardsLookup[i];
      }

      for (let i in uniqueAwardname) {
        uniqueLocalAwards.push(uniqueAwardname[i]);
      }

      if (uniqueLocalAwards.length === 0) {
        return null; // Return null if there are no unique local awards
      }

      return (
        <Row className='addLocalawards'>
          <Col span={24}>
            <span className='small-txt display-block'> Please add your local awards: </span>
          </Col>
          <Col span={24}>
            <Select
              className='awardsselect'
              showSearch
              placeholder="Please select awards to add"
              optionLabelProp="label"
              onChange={(value) => {
                const award = {
                  attributeVal: value,
                  awards: props.memberids.map((eachMID) => ({
                    personGuid: eachMID.personGuid,
                    memberId: eachMID.memberId,
                    attributeVal: value,
                    alreadyExist: !!state.localAwards.find(
                      (eachLocalAward) => eachLocalAward.attributeVal === value && eachLocalAward.memberId === eachMID.memberId
                    ),
                  })),
                  type: 'localAward',
                  method: 'add-localAward'
                };

                showLinkedMIDPopup();
                selectedAward(award)
              } }
              style={{ width: "100%" }}
              value={null}
            >
              {uniqueLocalAwards.map((awards) => (
                <Select.Option key={awards.id} label={awards.name} value={awards.name}>
                  <div>
                    <span className='m-l-10'>{awards.name}</span>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      );
    }

    return null; // Return null for any other cases
  }

  const MyLocalAwardsSection = () => {
    if (((pathName === '/my-profile' || pathName == '/alumni-dashboard') && props.profileloading) || (pathname.includes('/alumni-profile') && props.alumniProfileLoading) || props.localAwards_Loading || !state.localAwards) {
      return (
        <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
      );
    }

    if ((state.localAwards && state.localAwards.length > 0) && props.localAwards) {
      let awardResources = forSelfView ? groupedAwards(state.localAwards) : state.localAwards;
      return awardResources.map((eachLocalAward, index) => {
                return (
                  <div className='localawards' key={index}>
                    <Row type='flex' className='localawardssection' justify='flex-start' align='middle'>
                      <Col span={20}>
                        <Row type='flex' justify='flex-start' align='middle'>
                          <Col span={24}>
                            <span className='m-l-20 award-name display-block'>{eachLocalAward.attributeVal}</span>
                            { forSelfView &&  eachLocalAward.awards.map(eachAward => <span className='m-l-20 sub-title display-block' style={{ padding: '0px', color: '#919191' }}> MID - {eachAward.memberId}</span>)
                            }
                          </Col>
                        </Row>
                      </Col>
                      {(isEditableAwardsFrame && pathName === '/my-profile') &&
                        <Col span={2}>
                          <Row type='flex' justify='flex-start' align='middle'>
                            <Col span={24}>
                              <Popconfirm
                                title="Are you sure you want to delete this?"
                                onConfirm={() => {
                                  eachLocalAward.type = 'localAward';
                                  eachLocalAward.method = 'delete-localAward';
                                  showLinkedMIDPopup();
                                  selectedAward(eachLocalAward)
                                  // props.actions.deleteLocalAward(k.extendedProfileId, null, k.personGuid)
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                              </Popconfirm>
                            </Col>
                          </Row>
                        </Col>
                      }
                    </Row>
                  </div>
                );
              })
             
    }

    else return <div>{renderNoLocalAwardsFound()}</div>; // Return "no awards forund" for any other cases
  }

  const renderScoutings = () => {
    if (state.renamedAffiliations && state.AllExtendedProfileAwardsArray && props.nesa_reg) {
      let scoutingLookup = [...state.renamedAffiliations];
      let existingScouting = state.AllExtendedProfileAwardsArray;

      existingScouting.forEach((k, kindex) => {
        if (k.attributeId === '20') {
          scoutingLookup = scoutingLookup.filter(obj => {
            if (state.hasCurrentNESAmembership) { //// If hasCurrentNESAmembership is true, remove 'National Eagle Scout Association' from the affinities since it's included by default.
              return obj.name !== k.attributeVal && obj.name !== 'National Eagle Scout Association';
            } 
          return  obj.name !== k.attributeVal
          });
        }
      });
      // // Remove Order of the Arrow
      // scoutingLookup = scoutingLookup.filter(lookup => lookup.id !== 1); // Added back on AAG-915

      // Removing Duplicate Affiliations
      let uniqueAffiliations = [];
      let uniqueAffiliationName = {};
      let affiliationTitle;

      for (let i in scoutingLookup) {
        affiliationTitle = scoutingLookup[i]['name'];
        uniqueAffiliationName[affiliationTitle] = scoutingLookup[i];
      }

      for (let i in uniqueAffiliationName) {
        uniqueAffiliations.push(uniqueAffiliationName[i]);
      }
      console.log(uniqueAffiliations);

      if (uniqueAffiliations.length === 0) {
        return null; // Return null if there are no unique affiliations
      }

      return (
        <Row className='addscoutingaffiliations'>
          <Col span={24}>
            <span className='small-txt display-block'> Please select your Scouting Affiliation: </span>
          </Col>
          <Col span={24}>
            <Select
              className='scoutingsselect'
              showSearch
              placeholder="Please select Affiliations to add"
              optionLabelProp="label"
              style={{ width: "100%" }}
              onChange={(value) => {
                const award = {
                  attributeVal: value,
                  awards: props.memberids.map((eachMID) => ({
                    personGuid: eachMID.personGuid,
                    memberId: eachMID.memberId,
                    attributeVal: value,
                    alreadyExist: !!state.scoutingaffiliations.find(
                      (eachScouting) => eachScouting.attributeVal === value && eachScouting.memberId === eachMID.memberId
                    ),
                  })),
                  type: 'scoutings',
                  method: 'add-scoutings',
                };
               
                showLinkedMIDPopup();
                selectedAward(award)
              }
              } 
              value={null}
            >
              {uniqueAffiliations.map((scoutings) => (
                <Select.Option key={scoutings.id} label={scoutings.name} value={scoutings.name}>
                  <div>
                    <Avatar
                      src={scoutings.logo}
                      icon='shop'
                      size='small'
                    />
                    <span className='m-l-10'>  {scoutings.name}</span>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      );
    }
    return null; // Return null for any other cases
  }

  const rendermyscoutings = () => {
    if (state.renamedAffiliations_adding) {
      return (
        <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Adding Scouting Affiliations..." />
      );
    }
    if (state.renamedAffiliations_deleting) {
      return (
        <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Scouting Affiliations..." />
      );
    }
    if ( (forSelfView && props.scoutingAffiliationsLoading) || (pathname.includes('/alumni-profile') && props.alumniProfileLoading)) {
      return (
        <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Scouting Affiliations..." />
      );
    }
    if((Array.isArray(state.scoutingaffiliations) && state.scoutingaffiliations.length == 0) && !props.scoutingAffiliationsLoading && state.activeMembership.length == 0){
      return <div>{renderNoScoutingAffiliationFound()}</div>
    }
    if (state.scoutingaffiliations.length > 0 && state.renamedAffiliations) {
        let scoutingresources = forSelfView ? groupedAwards(state.scoutingaffiliations) : state.scoutingaffiliations;
      // Sort scoutings in ascending order by name
      state.renamedAffiliations.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      return scoutingresources.map((eachScouting, index) => {
        // if (k.attributeId === '20') {
          return state.renamedAffiliations.map((j, index) => {
            if (eachScouting.attributeVal === j.name && j.name != 'National Eagle Scout Association') {
              let imgurl = j.logo === "" || j.logo === null ? "../nonationalassociation.png" : j.logo;

              return (
                <div className='scoutingaffiliations' key={j.id}>
                <Row type='flex' className='scoutingaffiliationssection' justify='flex-start' align='middle'>
                    <Col span={5} className='text-center'>
                      <img src={imgurl} className='award-img' alt={j.name} />
                    </Col>
                    <Col span={17}>
                      <Row type='flex' justify='flex-start' align='middle'>
                        <Col span={24}>
                          <span className='m-l-20 award-name display-block'>{eachScouting.attributeVal}</span>
                          { forSelfView && eachScouting.awards.map(eachAward => <span className='m-l-20 sub-title display-block' style={{ padding: '0px', color: '#919191' }}> MID - {eachAward.memberId}</span>)
                          }
                        </Col>
                      </Row>
                    </Col>
                    {(isEditableAwardsFrame && pathName === '/my-profile') &&
                      <Col span={2}>
                        <Row type='flex' justify='flex-start' align='middle'>
                          <Col span={24}>
                            <Popconfirm
                              title="Are you sure you want to delete this?"
                              onConfirm={() =>  {
                                eachScouting.type = 'scoutings';
                                eachScouting.method= 'delete-scoutings';
                              showLinkedMIDPopup();
                              selectedAward(eachScouting)
                              // props.actions.deleteScouting("scoutings", k.extendedProfileId, null, k.personGuid)}
                            }
                          }
                              okText="Yes"
                              cancelText="No"
                            >
                              <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                            </Popconfirm>
                          </Col>
                        </Row>
                      </Col>
                    }
                    </Row>
                </div>
              );
            }
            return null; // Return null when the condition doesn't match
          });
        // }
        // return null; // Return null when the condition doesn't match
      });
    }   
  }

  const renderNoScoutingAffiliationFound = () => {
    return  <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
          </Col>
          <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
            <Row type='flex' align='bottom' justify='center'>
              <span className='memb-exp'>No Scouting Affiliations Exist!</span>
            </Row>
          </Col>
        </Col>
      </Row>
  }

  const renderNoCouncilAffiliationFound= () => {
    return  <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
          </Col>
          <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
            <Row type='flex' align='bottom' justify='center'>
              <span className='memb-exp'>No Council Affiliations Exist!</span>
            </Row>
          </Col>
        </Col>
      </Row>
  }

  const renderNoAffinityGroupFound= () => {
    return  <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
          </Col>
          <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
            <Row type='flex' align='bottom' justify='center'>
              <span className='memb-exp'>No Affinity Group Exist!</span>
            </Row>
          </Col>
        </Col>
      </Row>
  }

  const renderNoNationalAwardsFound= () => {
    return  <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
          </Col>
          <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
            <Row type='flex' align='bottom' justify='center'>
              <span className='memb-exp'>No National Awards Exist!</span>
            </Row>
          </Col>
        </Col>
      </Row>
  }
  
  const renderNoLocalAwardsFound= () => {
    return  <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
          </Col>
          <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
            <Row type='flex' align='bottom' justify='center'>
              <span className='memb-exp'>No Local Awards Exist!</span>
            </Row>
          </Col>
        </Col>
      </Row>
  }

  const renderPrivateAwardAlert = () => {
    return <Row className='width-100' type='flex' align='middle' justify='center'>
      <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
        </Col>
        <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
          <Row type='flex' align='bottom' justify='center'>
            <span className='memb-exp'>Alum has identified this as private information!</span>
          </Row>
        </Col>
      </Col>
    </Row>
  }

  const renderAllCouncils = () => {
    let loading = Boolean(props.councils_adding || props.councils_deleting || props.councilAffiliationsLoading || props.alumniProfileLoading);
    if (!loading && ((state.AllEagleInfo && state.AllEagleInfo.length !== 0) || (state.councilaffiliations.length > 0 && props.councils) || (state.getEagleCouncilInfo && state.getEagleCouncilInfo.length > 0))) {
      return <div className='council-affiliations-width'>
        {(state.getEagleCouncilInfo && state.getEagleCouncilInfo.length > 0) && renderCurrentCouncils()}
        {(state.AllEagleInfo && state.AllEagleInfo.length !== 0) && renderMyEagleCouncils()}
        {(state.councilaffiliations.length > 0 && props.councils) && renderMyCouncils()}
      </div>
    }
    else if(loading) return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Council Affiliations..." />;
    else return <div>{renderNoCouncilAffiliationFound()}</div>
  }

  const renderCouncils = () => {
    if (props.councils && state.AllExtendedProfileAwardsArray) {
      let councilLookup = [...props.councils];
      let existingCouncils = state.AllExtendedProfileAwardsArray;

      // Sort councils in ascending order
      props.councils.sort((a, b) => {
        return a.councilLong.localeCompare(b.councilLong);
      });

      let isAdded = existingCouncils.filter(function (obj) {
        return obj.attributeId === '21';
      });

      if (isAdded.length === 5) {
        return null; // Return null if 5 councils are already added
      }

      existingCouncils.forEach((k, kindex) => {
        if (k.attributeId === '21') {
          councilLookup = councilLookup.filter(function (obj) {
            return obj.councilLong !== k.attributeVal;
          });
        }
      });

      return (
        <Row className='addCouncilaffiliations'>
          <Col span={24}>
            <span className='small-txt display-block'> Please select your Council Affiliation: </span>
          </Col>
          <Col span={24}>
            <Select
              className='councilsselect'
              showSearch
              placeholder="Please select Affiliations to add"
              optionLabelProp="label"
              style={{ width: "100%" }}
              onChange={(value) => {
                const award = {
                  attributeVal: value,
                  awards: props.memberids.map((eachMID) => ({
                    personGuid: eachMID.personGuid,
                    memberId: eachMID.memberId,
                    attributeVal: value,
                    alreadyExist: !!state.councilaffiliations.find(
                      (eachCouncil) => eachCouncil.attributeVal === value && eachCouncil.memberId === eachMID.memberId
                    ),
                  })),
                  type: 'council',
                  method: 'add-council',
                };
              
                showLinkedMIDPopup();
                selectedAward(award);
              }}
              
              value={null}
            >
              {councilLookup.map((council) => (
                <Select.Option key={council.councilNumber} label={council.councilLong} value={council.councilLong}>
                  <div>
                    <span >{council.councilLong}</span>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      );
    }

    return null; // Return null for any other cases
  }

  const renderMyEagleCouncils = () => {
    // if (state.AllEagleInfo && state.AllEagleInfo.length !== 0) {
      // if (state.AllEagleInfo.eagleCouncilName) {
      //     let eagleCouncil = state.AllEagleInfo.eagleCouncilName ? state.AllEagleInfo.eagleCouncilName.replace(/ *\([^)]*\) */g, '') : "";

        return  state.AllEagleInfo.map(eachEagle => {
          return <div className='councilaffiliations'>
            <Row type='flex' className='councilaffiliationssection' justify='flex-start' align='middle'>
              <Col span={20}>
                <Row type='flex' justify='flex-start' align='middle'>
                  <Col span={24}>
                    <span className='m-l-20 award-name display-block'>{eachEagle.eagleCouncilName}</span>
                  </Col>
                </Row>
              </Col>
              <Col span={2}>
                <img className="eagle-logo" src='./eagle-scout.png' alt="Eagle Scout Logo" />
              </Col>
            </Row>
          </div>
          })
    //   }
    // // }
    // return null;
  }

  const renderMyCouncils = () => {
    // if (props.councils_adding) {
    //   return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Adding Council Affiliations..." />;
    // } else if (props.councils_deleting) {
    //   return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Council Affiliations..." />;
    // } else if((forSelfView && props.councilAffiliationsLoading) || (pathname.includes('/alumni-profile') && props.alumniProfileLoading)) {
    //   return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Council Affiliations..." />;
    // }
    //  else if((Array.isArray(state.councilaffiliations) && state.councilaffiliations.length == 0) && !props.councilAffiliationsLoading && (Array.isArray(props.councilAffiliationsReducerState) && props.councilAffiliationsReducerState.length > 0)){
    //   return <div>{renderNoAwardsFound()}</div>
    // } 
    // else
    //  if (state.councilaffiliations.length > 0 && props.councils ) {
      let councilresources = forSelfView ? groupedAwards(state.councilaffiliations) : state.councilaffiliations;
      return councilresources.map((eachCouncil, index) => {
        // if (k.attributeId === '21') {
          // if (state.AllEagleInfo.eagleCouncilName) {
          //   if (state.AllEagleInfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "") === eachCouncil.attributeVal) {
          //     return null;
          //   }
          // }

          return (
            <div className='councilaffiliations' key={index}>
              <Row type='flex' className='councilaffiliationssection' justify='flex-start' align='middle'>
                <Col span={22}>
                  <Row type='flex' justify='flex-start' align='middle'>
                    <Col span={24}>
                      <span className='m-l-20 award-name display-block'>{eachCouncil.attributeVal}</span>
                      {
                      forSelfView ? eachCouncil.awards.map(awards => (<span className='m-l-20 sub-title display-block' style={{ padding: '0px', color: '#919191' }}> MID - {awards.memberId}</span>)
                      ) : ''
                      }
                    </Col>
                  </Row>
                </Col>
                {(isEditableAwardsFrame && pathName === '/my-profile') && <Col span={2}>
                    <Row type='flex' justify='flex-start' align='middle'>
                      <Col span={24}>
                        <Popconfirm
                          title="Are you sure you want to delete this?"
                          onConfirm={() => {
                            eachCouncil.type = 'council';
                            eachCouncil.method= 'delete-council';
                            showLinkedMIDPopup();
                            selectedAward(eachCouncil)
                          }
                            //  props.actions.deleteScouting("council", k.extendedProfileId, null, k.personGuid)
                          }
                          okText="Yes"
                          cancelText="No"
                        >
                          <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                        </Popconfirm>
                      </Col>
                    </Row>
                  </Col>
                }
              </Row>
            </div>
          );
        // }
      //   return null; // Return null when the condition doesn't match
      });
    // }
    // return null; // Return null for any other cases
  }
  const renderCurrentCouncils = () => {
      let currentCouncilresources = state.getEagleCouncilInfo;
      return currentCouncilresources.map((eachCouncil, index) => {

          return (
            <div className='councilaffiliations' key={index}>
              <Row type='flex' className='councilaffiliationssection' justify='flex-start' align='middle'>
                <Col span={22}>
                  <Row type='flex' justify='flex-start' align='middle'>
                    <Col span={24}>
                      <span className='m-l-20 award-name display-block'>{eachCouncil.attributeVal}</span>
                      {<span className='m-l-20 sub-title display-block' style={{ padding: '0px', color: '#919191' }}> MID - {eachCouncil.memberId}</span>}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          );
      });
  }

  const renderAffinityGroups = () => {
    if (props.affinities && state.AllExtendedProfileAwardsArray) {
      let affinityLookup = [...props.affinities];
      let existingAffinities = state.AllExtendedProfileAwardsArray;

      existingAffinities.forEach((k, kindex) => {
        if (k.attributeId === '22') {
          affinityLookup = affinityLookup.filter(obj => {
            return obj.name !== k.attributeVal;
          });
        }
      });

      // Removing duplicate affinities
      let uniqueAffinities = [];
      let uniqueAffinityName = {};
      let affinityTitle;

      for (let i in affinityLookup) {
        affinityTitle = affinityLookup[i]['name'];
        uniqueAffinityName[affinityTitle] = affinityLookup[i];
      }

      for (let i in uniqueAffinityName) {
        uniqueAffinities.push(uniqueAffinityName[i]);
      }

      if (uniqueAffinities.length === 0) {
        return null; // Return null if there are no unique affinities
      }

      return (
        <Row className='addAffinitygroups'>
          <Col span={24}>
            <span className='small-txt display-block'> Please select your Affinity Group Affiliation: </span>
          </Col>
          <Col span={24}>
            <Select
              className='affinitiesselect'
              showSearch
              placeholder="Please select Affiliations to add"
              optionLabelProp="label"
              onChange={(value) => {
                const award = {
                  attributeVal: value,
                  awards: props.memberids.map((eachMID) => ({
                    personGuid: eachMID.personGuid,
                    memberId: eachMID.memberId,
                    attributeVal: value,
                    alreadyExist: !!state.affinities.find(
                      (eachAffinity) => eachAffinity.attributeVal === value && eachAffinity.memberId === eachMID.memberId
                    ),
                  })),
                  type: 'affinity',
                  method: 'add-affinity'
                };
                
                showLinkedMIDPopup();
                selectedAward(award)
              } }
              style={{ width: "100%" }}
              value={null}
            >
              {uniqueAffinities.map((affinities) => (
                <Select.Option key={affinities.id} label={affinities.name} value={affinities.name}>
                  <div>
                    <Avatar
                      src={affinities.logo}
                      icon='shop'
                      size='small'
                    />
                    <span className='m-l-10'>  {affinities.name}</span>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      );
    }

    return null; // Return null for any other cases
  }

  const renderMyAffinityGroups = () => {
    if (props.affinities_loading) {
      return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />;
    }
    if (props.affinities_deleting) {
      return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Affinity Group..." />;
    }
    if (((pathName === '/my-profile' || pathName == '/alumni-dashboard') && props.profileloading) || (pathname.includes('/alumni-profile') && props.alumniProfileLoading) || !state.affinities) {
      return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />;
    }

    if ((state.affinities && state.affinities.length > 0) && props.affinities) {
      let affinityResources = forSelfView ? groupedAwards(state.affinities) : state.affinities;

      if (affinityResources.length == 0) {
        return <Row className='width-100' type='flex' align='middle' justify='center'>
          <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img className='memb-img' src={noAwardsPng} alt="No Awards Found" />
            </Col>
            <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18}>
              <Row type='flex' align='bottom' justify='center'>
                <span className='memb-exp'>No Awards Found!</span>
              </Row>
            </Col>
          </Col>
        </Row>
      } else {
        props.affinities.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        return affinityResources.map((eachAffinity, index) => {
          // if (eachAffinity.attributeId === '22') {
            return props.affinities.map((j, index) => {
              if (eachAffinity.attributeVal === j.name) {
                let imgurl = (j.logo === "" || j.logo === null) ? "../nonationalassociation.png" : j.logo;
                return (
                  <div className='affinitygroups' key={index}>
                    <Row type='flex' className='affinitygroupssection' justify='flex-start' align='middle'>
                      <Col span={5} className='text-center'>
                        <img src={imgurl} className='award-img' alt={j.name} />
                      </Col>
                      <Col span={17}>
                        <Row type='flex' justify='flex-start' align='middle'>
                          <Col span={24}>
                            <span className='m-l-20 award-name display-block'>{eachAffinity.attributeVal}</span>
                            { forSelfView && eachAffinity.awards.map(eachAward =>  <span className='m-l-20 sub-title display-block' style={{ padding: '0px', color: '#919191' }}> MID - {eachAward.memberId}</span>)
                            }
                          </Col>
                        </Row>
                      </Col>
                      {(isEditableAwardsFrame && pathName === '/my-profile') &&
                        <Col span={2}>
                          <Row type='flex' justify='flex-start' align='middle'>
                            <Col span={24}>
                              <Popconfirm
                                title="Are you sure you want to delete this?"
                                onConfirm={() => {
                                  eachAffinity.type = 'affinity';
                                  eachAffinity.method= 'delete-affinity';
                                  showLinkedMIDPopup();
                                  selectedAward(eachAffinity)
                                  // props.actions.deleteAffinity(k.extendedProfileId, null, k.personGuid)
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <i className="fa fa-times-circle red pointer" aria-hidden="true"></i>
                              </Popconfirm>
                            </Col>
                          </Row>
                        </Col>
                      }
                    </Row>
                  </div>
                );
              }
              return null; // Return null when the condition doesn't match
            });
          // }
          // return null; // Return null when the condition doesn't match
        });
      }
    }
    return <div>{renderNoAffinityGroupFound()}</div>; // Return "no awards forund" for any other cases
  }

  const renderMyNationalAwards = () => {
    if (((pathName === '/my-profile' || pathName == '/alumni-dashboard') && props.profileloading) || (pathname.includes('/alumni-profile') && props.alumniProfileLoading) || props.awardsloading) {
      return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Awards..." />;
    }

    if (state.AllAlumniAwards) {
      const forNationalAwards = true;
      const nationalAwards = forSelfView ? groupedAwards(state.AllAlumniAwards, forNationalAwards) : state.AllAlumniAwards;

      if (nationalAwards.length === 0 || !state.privacysettingsOptions.isNationalAwardsDisplayed) {
        return <div>{renderNoNationalAwardsFound()}</div>;
      } else {
        return nationalAwards.map((award, index) => {
          let imageFilePath = award.awards.length > 0 ? award.awards[0].imageFilePath : '';
          let awardName = award.attributeVal;
          let imgurl = (imageFilePath === "" || imageFilePath === null) ? "../noawards.png" : imageFilePath;
          return (
            <Row key={index} type='flex' className='nationalawardssection' justify='flex-start' align='middle'>
              <Col span={6} className='text-center'>
                <img src={imgurl} className='award-img' alt={awardName} />
              </Col>
              <Col span={18}>
                <Row type='flex' justify='flex-start' align='middle'>
                  <Col span={24}>
                    <span className='award-name display-block'>{awardName}</span>
                    { forSelfView &&  award.awards.map(eachAward => <span className='m-l-20 sub-title display-block' style={{ padding: '0px', color: '#919191' }}> MID - {eachAward.memberId}</span>)
                            }
                  </Col>
                  {/* <Col span={24}>
                      <span className='award-date'>{k.dateEarned}</span>
                    </Col> */}
                </Row>
              </Col>
            </Row>
          );
        });
      }
    }

    return null;
  }

  const renderLinkedMIDModal = () => {
    let selectedAward = state.selectedAward;
    let method = selectedAward.length > 0 ? selectedAward[0].method : '';
    let checkDuplicated = []
    console.log("selectedAward before", selectedAward);
    return <Modal
      className='modalBox'
      width={"700px"}
      visible={state.isShowLinkedMIDPopup}
      // onOk={this.handleOk}
      onCancel={() => closeLinkedMIDPopup()}
      footer={false}>

      <h1 className='linkedID'>Linked Member ID's</h1>

      {selectedAward.length > 0 ? selectedAward[0].awards.map((award, i) => {
        let getMemberIDs = props.memberids.filter(eachMID => {
          return eachMID.memberId === award.memberId && !checkDuplicated.includes(eachMID.memberId);
        })[0];
        checkDuplicated.push(award.memberId);
        console.log("getMemberIDs", getMemberIDs);
        console.log("selectedAward After", selectedAward);
        if(getMemberIDs && getMemberIDs !== undefined){
        return <div>
          <div key={i} onClick={ () => { 
            if(!award.alreadyExist) dispatch({type: 'selectedLinkedMID', selectedLinkedMID : {award, index: i} })
            }} 
            className={ award.alreadyExist ? 
            'award-exist' :
             state.selectedLinkedMID.index == i ? `Linked-eagle-Info Linked-eagle-Info-active` 
             : `Linked-eagle-Info` 
             }>
            <div className='eagle-row'>
              { state.selectedLinkedMID.index == i ? <CheckCircleFilled className='blue-tick' /> : "" } 
              <div className='eagle-col'>
                <span className={award.alreadyExist ? 'award-exist-primaryText' : 'block'}>Member ID</span>
                <span className={award.alreadyExist ? 'award-exist-scondaryText' : 'gray'}>{getMemberIDs.memberId ? getMemberIDs.memberId : '-'}</span>
              </div>
              <div className='eagle-col'>
                <span className={award.alreadyExist ? 'award-exist-primaryText' : 'block'}>Council Name</span>
                <span className={award.alreadyExist ? 'award-exist-scondaryText' : 'gray'}>{getMemberIDs.eagleInfo.awardingCouncilName ? getMemberIDs.eagleInfo.awardingCouncilName : '-'}</span>
              </div>
              <div className='eagle-col'>
                <span className={award.alreadyExist ? 'award-exist-primaryText' : 'block'}>Board Review Date</span>
                <span className={award.alreadyExist ? 'award-exist-scondaryText' : 'gray'}>{getMemberIDs.eagleInfo.eagleBoardReviewDate ? getMemberIDs.eagleInfo.eagleBoardReviewDate : '-'}</span>
              </div>
              <div className='eagle-col'>
                {getMemberIDs.eagleInfo.eagleBoardReviewDate != '' && getMemberIDs.eagleInfo.eagleCertificateDate != '' &&
                <div className='img-div'>
                  <img className='eagle-img' src={'./eagle-scout.png'} alt='eagle-scout-logo'></img>
                </div>
      }
              </div>
            </div>

            <div className='eagle-row-2'>
              <div className='eagle-col'>
                <span className={award.alreadyExist ? 'award-exist-primaryText' : 'block'}>Eagle Unit Number</span>
                <span className={award.alreadyExist ? 'award-exist-scondaryText' : 'gray'}>{getMemberIDs.eagleInfo.eagleUnitNumber ? getMemberIDs.eagleInfo.eagleUnitNumber : '-'}</span>
              </div>
              <div className='eagle-col'>
                <span className={award.alreadyExist ? 'award-exist-primaryText' : 'block'}>Eagle Unit State</span>
                <span className={award.alreadyExist ? 'award-exist-scondaryText' : 'gray'}>{getMemberIDs.eagleInfo.eagleUnitState ? getMemberIDs.eagleInfo.eagleUnitState : '-'}</span>
              </div>
              <div className='eagle-col'>
                <span className={award.alreadyExist ? 'award-exist-primaryText' : 'block'}>Eagle Unit City</span>
                <span className={award.alreadyExist ? 'award-exist-scondaryText' : 'gray'}>{getMemberIDs.eagleInfo.eagleUnitCity ? getMemberIDs.eagleInfo.eagleUnitCity : '-'}</span>
              </div>
              <div className='eagle-col'>
                {getMemberIDs.isPrimary &&  
                <span className='block green'>
                  Primary <CheckCircleFilled className="tick-i" twoToneColor="#52c41a" />
                </span>
      }
              </div>
            </div>
            {award.alreadyExist &&
              <div className='award-exist-warning'> The selected award already associated with this Member ID! </div>
            } 
          </div><hr />
        </div>
        }
      })
        : ''}

      <div className='btn-row'>
        <Button id='cancel-btn' onClick={() => closeLinkedMIDPopup()}>Cancel</Button>
        <Button id='ok-btn' onClick={() => {
          let awardType = state.selectedAward.length > 0 ? state.selectedAward[0].type : ''
          let toAddAward = state.selectedAward.length > 0 ? state.selectedAward[0].method.includes('add') : '';
          if (toAddAward) {
            if (awardType == 'scoutings') {
              let awardName = state.selectedLinkedMID.award.attributeVal;
              if (awardName == 'National Eagle Scout Association') {
                let hasActiveMembership = [];
                hasActiveMembership = state.activeMembership.filter(activeMember => activeMember.memberId == state.selectedLinkedMID.award.memberId);
                if(hasActiveMembership.length > 0) {
                  dispatch({type: 'selectedActiveMember', selectedActiveMember: hasActiveMembership[0]});
                  showEagleScoutInformationPopup();
                 } else showInfoVisiblePopup();
              } else if (awardName == 'Scouting Alumni'){
                props.actions.addScoutings('Alumni Association', state.selectedLinkedMID.award.personGuid, forSelfView) // For AAG-1197, the request was to display "Scouting Alumni" instead of "Alumni Association" only for display purposes under the Scouting Alliliation frame. Therefore, we will revert it to "Alumni Association" to the API, when the `awardName` is "Scouting Alumni".
              } else {
                props.actions.addScoutings(awardName, state.selectedLinkedMID.award.personGuid, forSelfView)
              };
            }
            if (awardType == 'council') props.actions.addCouncils(state.selectedLinkedMID.award.attributeVal, state.selectedLinkedMID.award.personGuid, forSelfView);
            if (awardType == 'affinity') props.actions.addAffinities(state.selectedLinkedMID.award.attributeVal, state.selectedLinkedMID.award.personGuid, forSelfView);
            if (awardType == 'localAward') props.actions.addLocalAwards(state.selectedLinkedMID.award.attributeVal, state.selectedLinkedMID.award.personGuid, forSelfView);
          }
          else {
            if (awardType == 'scoutings' || awardType == 'council') props.actions.deleteScouting(awardType, state.selectedLinkedMID.award.extendedProfileId, null, state.selectedLinkedMID.award.personGuid);
            if (awardType == 'affinity') props.actions.deleteAffinity(state.selectedLinkedMID.award.extendedProfileId, null, state.selectedLinkedMID.award.personGuid);
            if (awardType == 'localAward') props.actions.deleteLocalAward(state.selectedLinkedMID.award.extendedProfileId, null, state.selectedLinkedMID.award.personGuid);
          }
          closeLinkedMIDPopup();
        }} >Ok</Button>
      </div>
    </Modal>
}
  return (
    <Row className=' margin-10' type="flex" justify="center" align="middle">
      <Col className="gutter-row">
        <div className='container min-height-550'>
          <div className='widget-content'>
            <Row type="flex" justify="space-between">
              <div className='widget-header-text'>
                My Scouting Affiliations
              </div>
              <div className='widget-header-tool'>
                {/* Add New button */}
              </div>
            </Row>
            <Row className={isEditableAwardsFrame ? 'widget-content-section height-360 flex-column-direction align-Top' : 'widget-content-section height-460 flex-column-direction align-Top'} type='flex'>
              {/* {(!state.privacysettingsOptions.isScoutingAffiliationsDisplayed && !forSelfView) 
              && renderPrivateAwardAlert()
              } */}
              {(state.privacysettingsOptions.isScoutingAffiliationsDisplayed || forSelfView) && state.hasCurrentNESAmembership && <div>
                {state.activeMembership.map(eachActiveMember => {
                  return <div className='scoutingaffiliations' key={eachActiveMember.Affiliation.id} onClick={() => {
                    (pathName === '/manage-memberid' || pathName === '/my-profile') ?
                    dispatch({type: 'selectedActiveMember', selectedActiveMember: eachActiveMember}) : {}
                  }}>
                    <Row type='flex' className='scoutingaffiliationssection' justify='flex-start' align='middle'>
                      <Col span={6} className='text-center'>
                        <img src={eachActiveMember.Affiliation.logo} className='award-img' alt={eachActiveMember.Affiliation.name} />
                      </Col>
                      <Col span={16}>
                        <Row type='flex' justify='flex-start' align='middle'>
                          <Col span={24} onClick={() =>{
                             (pathName === '/manage-memberid' || pathName === '/my-profile') ?
                             showEagleScoutInformationPopup() : {}
                          }}>
                            <Row type='flex' justify='flex-start' align='middle'>
                              <Col span={24}>
                                <span className='award-name display-block'>{Number(eachActiveMember.NESARegistrations.programId) === 30 ? 'NESA 5Year' : 'NESA Lifetime'}</span>
                              </Col>
                              {/* {(!isEditableAwardsFrame && pathName === '/manage-memberid') && */}
                              <Col span={24}>
                                <span className='m-l-0 award-date'>MID: {eachActiveMember.memberId ? eachActiveMember.memberId : "-"}</span>
                              </Col>
                {/* } */}
                {eachActiveMember.NESARegistrations.expireDate ?
                              <Col span={24}>
                                <span className='m-l-0 award-date'>expires {moment(eachActiveMember.NESARegistrations.expireDate).format('MM/DD/YYYY')}</span>
                              </Col>
                              : ''
                }
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
              })
              }
              </div>
              }
                  {/* {(state.privacysettingsOptions.isScoutingAffiliationsDisplayed || forSelfView) && <div className='width-100'>{rendermyscoutings()}</div> } */}

                    {props.isadmin ? (rendermyscoutings()) : (!state.privacysettingsOptions.isScoutingAffiliationsDisplayed && !forSelfView ? 
                      (renderPrivateAwardAlert()) : (
                        <div className='width-100'>
                          {rendermyscoutings()}
                        </div>
                      )
                    )}
            </Row>
              {(isEditableAwardsFrame && pathName === '/my-profile') && renderScoutings()}
          </div>
        </div>
      </Col>

      <Col className="gutter-row">
        <div className='container min-height-550'>
          <div className='widget-content'>
            <Row type="flex" justify="space-between">
              <div className='widget-header-text'>
                My Council Affiliations
              </div>
              <div className='widget-header-tool'>
                {/* Add New button */}
              </div>
            </Row>
            <Row className={isEditableAwardsFrame ? 'widget-content-section height-360 align-Top' : 'widget-content-section height-460 align-Top'} type="flex" >
              {/* Render the content for My Council Affiliations */}
              {/* {!state.privacysettingsOptions.isCouncilAffiliationsDisplayed && !forSelfView ? 
                renderPrivateAwardAlert() :
               <dev>
               {renderAllCouncils()}
             </dev>
              } */}

              {props.isadmin ? (renderAllCouncils()) : (!state.privacysettingsOptions.isCouncilAffiliationsDisplayed && !forSelfView ?
                (renderPrivateAwardAlert()) : (
                  <div className='width-100'>
                    {renderAllCouncils()}
                  </div>
                )
              )}
            </Row>
              {(isEditableAwardsFrame && pathName === '/my-profile') && renderCouncils()}
          </div>
        </div>
      </Col>

      <Col className="gutter-row">
        <div className='container min-height-550'>
          <div className='widget-content'>
            <Row type="flex" justify="space-between">
              <div className='widget-header-text'>
                My Affinity Groups
              </div>
              <div className='widget-header-tool'>
                {/* Add New button */}
              </div>
            </Row>
            <Row className={isEditableAwardsFrame ? 'widget-content-section height-360 align-Top' : 'widget-content-section height-460 align-Top'} type="flex" >
              {/* Render the content for My Affinity Groups */}
              {/* {!state.privacysettingsOptions.isAffinityGroupsDisplayed && !forSelfView ?
                renderPrivateAwardAlert() :
                <div className='affinitygroups'>
                 {renderMyAffinityGroups()}
                </div>
              } */}

                {props.isadmin ? (renderMyAffinityGroups()) : (!state.privacysettingsOptions.isAffinityGroupsDisplayed && !forSelfView ? 
                  (renderPrivateAwardAlert()) : (
                    <div className='width-100'>
                      {renderMyAffinityGroups()}
                    </div>
                  )
                )}
            </Row>
              {(isEditableAwardsFrame && pathName === '/my-profile') && renderAffinityGroups()}
          </div>
        </div>
      </Col>

      <Col className="gutter-row">
        <div className='container min-height-550'>
          <div className='widget-content'>
            <Row type="flex" justify="space-between">
              <div className='widget-header-text'>
                My National Awards
              </div>
              <div className='widget-header-tool'>
                {/* Add New button */}
              </div>
            </Row>
            <Row className={isEditableAwardsFrame ? 'widget-content-section height-360 align-Top' : 'widget-content-section height-460 align-Top'} type='flex' >
              {/* Render the content for My National Awards */}
              {/* {!state.privacysettingsOptions.isAwardsDisplayed && !forSelfView ?
                renderPrivateAwardAlert() :
                <div style={{ width: '100%' }}>
                  {renderMyNationalAwards()}
                </div>
              } */}
              {props.isadmin ? (renderMyNationalAwards()) : (!state.privacysettingsOptions.isNationalAwardsDisplayed && !forSelfView ?
                (renderPrivateAwardAlert()) : (
                  <div className='width-100'>
                    {renderMyNationalAwards()}
                  </div>
                )
              )}
            </Row>
          </div>
        </div>
      </Col>

      <Col className="gutter-row">
        <div className='container min-height-550'>
          <div className='widget-content'>
            <Row type="flex" justify="space-between">
              <div className='widget-header-text'>
                My Local Awards
              </div>
            </Row>
            <Row className={isEditableAwardsFrame ? 'widget-content-section height-360 align-Top' : 'widget-content-section height-460 align-Top'} type="flex" >
              {/* Render the content for My Local Awards */}
              {/* {!state.privacysettingsOptions.isAwardsDisplayed && !forSelfView ?
                renderPrivateAwardAlert() :
                <div className='width-100'>
                  {MyLocalAwardsSection()}
                </div>
              } */}
              {props.isadmin ? (MyLocalAwardsSection()) : (!state.privacysettingsOptions.isLocalAwardsDisplayed && !forSelfView ?
                (renderPrivateAwardAlert()) : (
                  <div className='width-100'>
                    {MyLocalAwardsSection()}
                  </div>
                )
              )}
            </Row>
              {(isEditableAwardsFrame && pathName === '/my-profile') && renderLocalAwardsSection()}
          </div>
        </div>
      </Col>

      <Modal
          centered
          className='NESARegistrationsModal'
          title=""
          visible={state.showNESARegistrationsModal}
          onCancel={() => {
            dispatch({ type: 'hideNESARegistrationsModal' });
        }}
          footer={false}
        >
          <Row gutter={48} className="eagle-info-container">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <fieldset style={{ padding: "20px" }}>
                <legend>NESA Memberships:</legend>
                <NESARegistrations personGUID={state.selectedActiveMember ? state.selectedActiveMember.personGuid : ''}
                />
                {/* {!state.hasCurrentNESAmembership  && 
            <div className='note-text'>
            NOTE: You do not have any current NESA membership for this Member ID
            </div>
            } */}
              </fieldset>
            </Col>
          </Row>

        </Modal> 
       { state.EagleScoutInfoVisible &&
          <Modal
          centered
          className='EagleScoutInformationModal'
          title="Eagle Information"
          visible={state.EagleScoutInfoVisible}
          closable={false}
          footer={[
            <Row type='flex' style={{ justifyContent: 'end', alignItems: 'center' }}>
              <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={13} xl={13} >
                <div className='step-container margin-top-20' >
                  <Button type="primary" className='back-btn' style={{ fontSize: '13px', width: '100%' , margin: '0px'}}  onClick={() => {
                    closeEagleScoutInformationPopup()
                    dispatch({ type: 'showNESARegistrationsModal' });
                    props.actions.getNESARegistrations(state.selectedActiveMember.personGuid)
                    }}>
                    View Memberships
                    </Button>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                <div className='step-container margin-top-20' >
                  <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => closeEagleScoutInformationPopup()}>
                    OK
                  </Button>
                </div>
              </Col>
            </Row>
          ]}
          >
            <Row gutter={48} className="eagle-info-container">
              <Row className="eaglescout-info-panel">
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Member ID: </label>
                      <label className='membership-field-value'>{state.selectedActiveMember.memberId ? state.selectedActiveMember.memberId : '- -'}</label>
                  </Col>
                  <Col span={14}>
                      <label className='membership-field-label'> First Name:  </label>
                      <label className='membership-field-value'>{state.selectedActiveMember.eagleInfo.firstName ? state.selectedActiveMember.eagleInfo.firstName : '- -'}</label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Middle Name:  </label>
                      <label className='membership-field-value'>{state.selectedActiveMember.eagleInfo.middleName ? state.selectedActiveMember.eagleInfo.middleName : '- -'}</label>
                  </Col>
                  <Col span={14}>
                      <label className='membership-field-label'>  Last Name:  </label>
                      <label className='membership-field-value'>{state.selectedActiveMember.eagleInfo.lastName ? state.selectedActiveMember.eagleInfo.lastName : '- -'}</label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Date of Birth:  </label>
                      <label className='membership-field-value'>{
                        state.selectedActiveMember.eagleInfo.dateOfBirth ? moment(state.selectedActiveMember.eagleInfo.dateOfBirth).format('MM/DD/YYYY') : '---'
                      }</label>
                  </Col>
                  <label className='membership-field-label'>  Board Review Date:  </label>
                  <label className='membership-field-value'>
                    {
                      state.selectedActiveMember.eagleInfo.eagleBoardReviewDate ? moment(state.selectedActiveMember.eagleInfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '---'
                    }
                  </label>
              </Row>

              <Row type='flex' align='middle'>
                  <Col span={10}>
                    <label className='membership-field-label'>  Eagle Unit Number:  </label>
                    <label className='membership-field-value'>
                      {state.selectedActiveMember.eagleInfo.eagleUnitNumber ? state.selectedActiveMember.eagleInfo.eagleUnitNumber : '---'}
                    </label>
                  </Col>
                  <Col span={14}>
                  <label className='membership-field-label'>  Eagle Scout City:  </label>
                  <label className='membership-field-value'>
                    {state.selectedActiveMember.eagleInfo.eagleUnitCity ? state.selectedActiveMember.eagleInfo.eagleUnitCity : '---'}
                  </label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Eagle Scout State:  </label>
                      <label className='membership-field-value'>{state.selectedActiveMember.eagleInfo.eagleUnitState ? state.selectedActiveMember.eagleInfo.eagleUnitState : '---'}</label>
                  </Col>
                  <Col span={14}>
                      
                  </Col>
              </Row>
              </Row>
            </Row>

            <div className="MembershipInfoHeader">
                NESA MEMBERSHIP INFORMATION
            </div>
            <div className="MembershipInfoHeaderPath"></div>

            {renderEagleMembershipInfo()}

          </Modal>
          }

      <div>
        {renderLinkedMIDModal()}
      </div>

      <div>
          <NesaRegistrationsInfoModal InfoVisible={state.InfoVisible} showInfoVisiblePopup={showInfoVisiblePopup} closeInfoVisiblePopup = {closeInfoVisiblePopup} />
      </div>
    </Row>
  );
}

const mapStateToProps = (state) => ({
  nesa_loading: state.nesaregistrationreducer.loading,
  nesa_reg: state.nesaregistrationreducer.reg,
  localAwards_Loading: state.localAwardsReducer.loading,
  profileloading: state.profilereducer.loading,
  profileinfo: state.profilereducer.profileinfo,
  alumniProfileinfo: state.alumniinforeducer.profileinfo,
  alumniProfileLoading: state.alumniinforeducer.loading,
  awardsloading: state.awardsreducer.loading,
  awards: state.awardsreducer.awards,
  alumniAwards: state.alumniawardsreducer.awards,
  affinities_loading: state.affinitiesreducer.loading,
  affinities: state.affinitiesreducer.affinities,
  localAwards: state.localAwardsReducer.localAwards,
  scoutings_loading: state.scoutingsreducer.loading,
  scoutings: state.scoutingsreducer.scoutings,
  scoutings_deleting: state.scoutingsdeletereducer.loading,
  scoutings_adding: state.scoutingsaddreducer.loading,
  councils: state.councilsreducer.councils,
  councils_adding: state.councilsaddreducer.loading,
  councils_deleting: state.councildeletereducer.loading,
  eagleInfo: state.eagleinforeducer.eagleinfo,

  alumniEagleinfo: state.alumnieagleinforeducer.eagleinfo,

  memberids: state.getmemberidreducer.memberids,
  alumniAndLocalAwardsReducerState: state.getAlumniAndLocalAwardsReducer.alumniAndLocalAwards,
  loadingAlumniAndLocalAwards: state.getAlumniAndLocalAwardsReducer.loading,
  scoutingAffiliationsReducerState: state.getScoutingAffiliationsReducer.scoutingAffiliations,
  scoutingAffiliationsLoading: state.getScoutingAffiliationsReducer.loading,
  councilAffiliationsReducerState: state.getCouncilAffiliationsReducer.councilAffiliations,
  councilAffiliationsLoading: state.getCouncilAffiliationsReducer.loading,
  affinityGroupsReducerState: state.getAffinityGropusReducer.affinityGroups,
  affinityGroupsLoading: state.getAffinityGropusReducer.loading,

  privacysettingsOptions: state.alumniPrivacyOptionsreducer.privacysettingsOptions,
  isLoadingPrivacySettings: state.alumniPrivacyOptionsreducer.loading,
  isadmin: state.isadminreducer.isadmin,

  councilByZipLoading: state.getCouncilByZipCodeReducer.loading,
  councilByZip: state.getCouncilByZipCodeReducer.councilByZip,
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyAwardsComponent));


// WEBPACK FOOTER //
// ./src/components/Inc/AwardSections.js